export default __webpack_public_path__ + "static/media/Molly_9781408335642.d8cc6952.jpg";